import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { bootBlock, findBlocks } from '../../src/js/block-boot';

const swiperInstances = new WeakMap();

function initTestimonials(root) {
  findBlocks(root, '.testimonials').forEach((block) => {
    if (swiperInstances.has(block)) return;

    const swiperEl = block.querySelector('.testimonials__swiper');
    if (!swiperEl) return;

    const instance = new Swiper(swiperEl, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
        },
      },
      navigation: {
        nextEl: block.querySelector('.testimonials__btn-next'),
        addIcons: false,
      },
      pagination: {
        el: block.querySelector('.testimonials__pagination'),
        clickable: true,
      },
      a11y: {
        enabled: true,
      },
    });

    swiperInstances.set(block, instance);
  });
}

bootBlock('testimonials', initTestimonials);
